<!--
 This component provides a navigation drawer, in voyages
 currently this is mostly just a placeholder, but keeps the UI consistent.
-->

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

// True if the page is part of the voyage management
// system, as it shows a different sidebar.
const isVoyageManagementPage = computed(
  () => route.meta.isVoyageManagement ?? false,
);
</script>

<template>
  <v-navigation-drawer
    v-if="isVoyageManagementPage"
    :model-value="true"
    :rail="true"
    class="navigation-drawer menu-font scoll-bar"
    rail-width="70"
    permanent
    dark
    width="280"
  >
  </v-navigation-drawer>
</template>

<style lang="scss" scoped>
$error-color: #ff2424;

.navigation-drawer {
  background-color: #242d40;
}
</style>
